// extracted by mini-css-extract-plugin
export default {"builder-edit-element":"EditElement_builder-edit-element__tl-g4"};